import { request } from '@kibt/krn-utils';
import { replacePathParams } from './utils';
export type BaseModel = Record<
    string,
    {
        parameters: {
            query?: Record<string, any>;
            path?: Record<string, any>;
        };
        requestBody: Record<string, any>;
        responses: any;
    }
>;
interface IRequestConfig {
    baseURL: string;
    method: 'get' | 'post';
    url: string;
    params: Record<string, any>;
    data: Record<string, any>;
    headers: Record<string, any>;
    [k: string]: any;
}
export interface IExtra {
    headers?: Record<string, any>;
    coverParams?: Record<string, any>;
    toastError?: boolean;
    [k: string]: any;
}
export function createRequest<Model extends BaseModel>(
    baseConfig?: { baseURL?: string | (() => string) },
    interceptor?: {
        request: (config?: Partial<IRequestConfig>) => Partial<IRequestConfig>;
        response: (data: any, extra: any) => any;
    }
) {
    return function innerRequest<U extends keyof Model>(url: U & string, payload?: any, extra?: IExtra): Promise<Model[U]['responses']> {
        const [method, ...restStrList] = url.split('/');
        const fetchFn = (request as any)[method.toLocaleLowerCase()] as any;
        if (!fetchFn) {
            throw new Error(`暂不支持此方法: ${method}`);
        }
        const isGet = method.toLocaleLowerCase() === 'get';
        const innerConfig = {
            ...baseConfig,
            method,
            url: restStrList.join('/'),
            params: payload?.query,
            data: payload?.body,
            headers: extra?.headers,
            baseURL: typeof baseConfig?.baseURL === 'function' ? baseConfig.baseURL() : baseConfig?.baseURL, // 为了支持 webpack 打包的场景
        };
        const config = interceptor?.request?.(innerConfig as IRequestConfig) ?? innerConfig;
        const restUrl = replacePathParams(config.url, payload?.path);
        const baseUrl = config?.baseURL ?? '';
        const finalUrl = `${baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`}${restUrl}`;
        // TODO: 'request'方法只接受body或query其中之一啊, amazing....
        const params = isGet ? { params: payload?.query } : payload?.body ?? payload?.query;
        const innerExtra = {
            headers: config.headers ?? {},
            coverParams: extra?.coverParams ?? {},
            toastError: extra?.toastError ?? true,
        };
        console.log('api full path: \n', finalUrl, params);
        const startTime = Date.now();
        return fetchFn(finalUrl, params, innerExtra)
            .then(d => {
                return (
                    interceptor?.response?.(d, {
                        ...extra,
                        config: {
                            url: finalUrl,
                            params,
                        },
                    }) ?? d
                );
            })
            .finally(() => {
                console.log('api full path: done \n', finalUrl, Date.now() - startTime);
            });
    };
}
